import styled from "@emotion/styled";
import { motion } from "framer-motion";

export const ClearButton = styled(motion.button)(({ theme }) => ({
  borderRadius: "16px",
  background: theme.button.filter.unselected.surface.default,
  fontWeight: "500",
  border: "1px solid transparent",
  padding: "0 14px 0 14px",
  marginRight: "4px",
  textAlign: "center",
  fontSize: "12px",
  height: "32px",
  color: theme.button.primary.surface.active,
  ":hover": {
    background: theme.surface.main.secondary.hover,
    border: `1px solid ${theme.button.primary.surface.active}`,
  },
  whiteSpace: "nowrap",
}));
